import { CircleAlert, LoaderCircle, RefreshCw } from 'lucide-react'
import { cn } from '../../lib/utils.js'
import { Button } from './button.jsx'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from './card.jsx'

function LoadingPanel({ className, label = '正在加载' }) {
  return (
    <Card className={cn('mx-auto max-w-md', className)} role="status">
      <CardContent className="flex items-center justify-center gap-3 py-8 text-text-secondary">
        <LoaderCircle className="spin" size={22} />
        <span>{label}</span>
      </CardContent>
    </Card>
  )
}

function EmptyPanel({
  action,
  className,
  icon,
  message,
  title,
}) {
  return (
    <Card className={cn('mx-auto max-w-md text-center', className)}>
      <CardHeader className="items-center pt-8">
        {icon && <div className="text-text-secondary">{icon}</div>}
        <CardTitle>{title}</CardTitle>
        {message && <CardDescription>{message}</CardDescription>}
      </CardHeader>
      {action && (
        <CardContent className="flex justify-center pt-2">
          {action}
        </CardContent>
      )}
    </Card>
  )
}

function ErrorPanel({
  action,
  className,
  message,
  onRetry,
  title = '加载失败',
}) {
  return (
    <Card className={cn('mx-auto max-w-md border-red-200 text-center', className)} role="alert">
      <CardHeader className="items-center pt-8">
        <CircleAlert className="text-danger" size={28} />
        <CardTitle>{title}</CardTitle>
        <CardDescription>{message}</CardDescription>
      </CardHeader>
      {(onRetry || action) && (
        <CardContent className="flex flex-wrap justify-center gap-2 pt-2">
          {onRetry && (
            <Button variant="secondary" onClick={onRetry}>
              <RefreshCw size={16} />
              重试
            </Button>
          )}
          {action}
        </CardContent>
      )}
    </Card>
  )
}

export { EmptyPanel, ErrorPanel, LoadingPanel }
